var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5938 2.59375L15.4062 5.40625C15.5521 5.55208 15.5521 5.69792 15.4062 5.84375L8.5625 12.6875L5.6875 13C5.47917 13.0208 5.30208 12.9688 5.15625 12.8438C5.03125 12.6979 4.97917 12.5208 5 12.3125L5.3125 9.4375L12.1562 2.59375C12.3021 2.44792 12.4479 2.44792 12.5938 2.59375ZM17.6562 1.875C17.8854 2.125 18 2.41667 18 2.75C18 3.08333 17.8854 3.375 17.6562 3.625L16.5312 4.71875C16.3854 4.86458 16.2396 4.86458 16.0938 4.71875L13.2812 1.90625C13.1354 1.76042 13.1354 1.61458 13.2812 1.46875L14.4062 0.375C14.6354 0.125 14.9167 0 15.25 0C15.5833 0 15.875 0.125 16.125 0.375L17.6562 1.875ZM12 10.8125C12 10.7083 12.0417 10.625 12.125 10.5625L13.375 9.3125C13.4792 9.1875 13.6042 9.15625 13.75 9.21875C13.9167 9.28125 14 9.39583 14 9.5625V14.5C14 14.9167 13.8542 15.2708 13.5625 15.5625C13.2708 15.8542 12.9167 16 12.5 16H1.5C1.08333 16 0.729167 15.8542 0.4375 15.5625C0.145833 15.2708 0 14.9167 0 14.5V3.5C0 3.08333 0.145833 2.72917 0.4375 2.4375C0.729167 2.14583 1.08333 2 1.5 2H10.4375C10.6042 2 10.7188 2.08333 10.7812 2.25C10.8438 2.39583 10.8125 2.52083 10.6875 2.625L9.4375 3.875C9.375 3.95833 9.29167 4 9.1875 4H2V14H12V10.8125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.298da4d78d9259f76595746aa5f98941.svg";
export { ForwardRef as ReactComponent };